/**
 * Created by dmitry on 17.06.2025
 */

const StickersBookJokerTutorial = function () {
    return new TutorialScenario(StickersBookJokerTutorial.NAME, {
        manual: true,

        listSteps: StickersBookJokerTutorial.listSteps,

        isAvailable: function () {
            return !cleverapps.forces.isShown(Forces.SEASON_COLLECTIONS_JOKER_TUTORIAL)
                && cleverapps.stickersBook.isAvailable()
                && cleverapps.stickersBook.collections.find((collection) => collection.isAvailable() && !collection.isCompleted && collection.stickers.find((sticker) => sticker.getState() === Sticker.STATE_CLOSED));
        }
    });
};

StickersBookJokerTutorial.listSteps = function () {
    const steps = [{
        onStart: function () {
            if (!cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            const findTarget = () => cleverapps.focusManager.currentWindow().icons.find((iconView) => {
                const collection = iconView.collection;
                return collection.isAvailable()
                        && !collection.isCompleted
                        && collection.stickers.find((sticker) => sticker.getState() === Sticker.STATE_CLOSED);
            });

            const createForce = () => {
                this.target = findTarget();
                this.target.setPrizeBarTooltipEnabled(false);
                this.force = cleverapps.forces.create(this.target, Forces.SEASON_COLLECTIONS_JOKER_TUTORIAL);
            };

            cleverapps.focusManager.display({
                focus: "StickersBookJokerTutorialCollectionIconClicked",
                stack: true,
                actions: [
                    (f) => {
                        cleverapps.focusManager.currentWindow().scroll.scrollTo(findTarget(), 0.7, {
                            callback: f
                        });
                    },

                    (f) => {
                        createForce();
                        cleverapps.tutorial.on("stickers_collection_icon_clicked", f, this);
                    },

                    (f) => {
                        this.target.setPrizeBarTooltipEnabled(true);
                        this.force = undefined;
                        cleverapps.forces.closeRunningForce();
                        f();
                    }
                ]
            });

            cleverapps.tutorial.on("onResize", () => {
                if (this.force) {
                    this.force.close();
                    createForce();
                }
            }, this);

            cleverapps.tutorial.on("window_shown", () => this.finish(), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }, {
        onStart: function () {
            if (!cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            const createForce = () => {
                const collectionWindow = cleverapps.focusManager.currentWindow();
                const target = collectionWindow.stickers.find((stickerView) => stickerView.sticker.getState() === Sticker.STATE_CLOSED);

                this.force = cleverapps.forces.create(target, {
                    finger: true
                }, {
                    highlights: [collectionWindow.component && collectionWindow.component.puzzleBg].filter(Boolean)
                });
            };

            cleverapps.focusManager.display({
                focus: "StickersBookJokerTutorialTooltip",
                stack: true,
                actions: [
                    (f) => {
                        createForce();
                        cleverapps.tutorial.on("stickers_collection_window_tooltip_shown", f, this);
                    },

                    (f) => {
                        this.force = undefined;
                        cleverapps.forces.closeRunningForce();

                        const collectionWindow = cleverapps.focusManager.currentWindow();
                        const stickerTooltip = collectionWindow.stickerTooltip;

                        const dialogue = new MinimalDialogue({
                            text: Messages.get("JokerTutorialDialogueText"),
                            position: MinimalDialogue.POSITIONS.TOP,
                            rects: [stickerTooltip.getSceneBoundingBox()]
                        });

                        collectionWindow.addChild(dialogue);
                        dialogue.display();
                        dialogue.runAction(new cc.Sequence(
                            new cc.DelayTime(5),
                            new cc.CallFunc(() => {
                                dialogue.remove();
                            })
                        ));

                        f();
                    }
                ]
            });

            cleverapps.tutorial.on("onResize", () => {
                if (this.force) {
                    this.force.close();
                    createForce();
                }
            }, this);

            cleverapps.tutorial.on("window_closed", () => this.finish(), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }];

    return steps.map((step) => new TutorialStep(step));
};

StickersBookJokerTutorial.NAME = "sticker_book_joker_tutorial";
